import { useTranslation } from "lib/i18n/translation"

import SkeletonLink from "components/common/skeleton-link"

import { get } from "lib/redirects"

export const Menu =  ({ links, current }) => {
	const { c } = useTranslation("common")

	return (
		<nav className="contextual relative" aria-label={c("top-lists-contextual-navigation")}>
			<nav className="filters larger" aria-label={c("filters")}>
				{links.map(({ title, target }) => {
					const realTarget = get(target)

					return (
						<SkeletonLink
							key={title}
							href={target}
							as={realTarget}
						>
							<a
								title={c(title)}
								className={`${(current && current.target == target) ? "active" : ""}`}
							>
								{c(title)}
							</a>
						</SkeletonLink>
					)
				})}
			</nav>
		</nav>
	)
}
